export function requiredFieldAvailableSelectAffiliate(data) {
  const { selectedAffiliateType } = data;
  if (selectedAffiliateType.length > 0)
    return true;
  else return false;
}
